/**
 * @generated SignedSource<<8347b372eccce603cee2da4a3f8b2d6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LimitPeriodType = "MINUTES" | "SESSION";
export type ToolUsageType = "AIStudio" | "CustomizerAIImageGenerator" | "CustomizerDesignGenerator" | "CustomizerProductStaging" | "CustomizerVirtualTryOn";
export type CreateToolUsageRuleInput = {
  allowLoggedUsers: boolean;
  allowNonLoggedUsers: boolean;
  limitEnabled: boolean;
  limitPeriodMinutes?: number | null;
  limitPeriodType?: LimitPeriodType | null;
  maxOperations?: number | null;
  toolType: ToolUsageType;
};
export type usageControlsMutationsCreateMutation$variables = {
  input: CreateToolUsageRuleInput;
};
export type usageControlsMutationsCreateMutation$data = {
  readonly createToolUsageRule: {
    readonly allowLoggedUsers: boolean;
    readonly allowNonLoggedUsers: boolean;
    readonly applyToAllTools: boolean;
    readonly id: string;
    readonly limitEnabled: boolean;
    readonly limitPeriodMinutes: number | null;
    readonly limitPeriodType: LimitPeriodType | null;
    readonly maxOperations: number | null;
    readonly toolTargets: ReadonlyArray<{
      readonly toolType: ToolUsageType | null;
    }>;
    readonly toolUsageRuleID: number;
  } | null;
};
export type usageControlsMutationsCreateMutation = {
  response: usageControlsMutationsCreateMutation$data;
  variables: usageControlsMutationsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToolUsageRule",
    "kind": "LinkedField",
    "name": "createToolUsageRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toolUsageRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "applyToAllTools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowLoggedUsers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowNonLoggedUsers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limitEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limitPeriodType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxOperations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "limitPeriodMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ToolUsageRuleToolTarget",
        "kind": "LinkedField",
        "name": "toolTargets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usageControlsMutationsCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usageControlsMutationsCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0b73df69f46bf36db43aa110fced651d",
    "id": null,
    "metadata": {},
    "name": "usageControlsMutationsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation usageControlsMutationsCreateMutation(\n  $input: CreateToolUsageRuleInput!\n) {\n  createToolUsageRule(input: $input) {\n    id\n    toolUsageRuleID\n    applyToAllTools\n    allowLoggedUsers\n    allowNonLoggedUsers\n    limitEnabled\n    limitPeriodType\n    maxOperations\n    limitPeriodMinutes\n    toolTargets {\n      toolType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36b0bdaf78ff875bbc9f93ead0da575a";

export default node;
